import { useQuery } from "@tanstack/react-query"

import { api } from "@/api"
import { ENDPOINTS } from "@/constants"
import { useAuth } from "@/contexts/auth"
const getSubscriptionById = async (
  subscriptionId: string
) => {
  const url = `${ENDPOINTS.SUBSCRIPTIONS}/${subscriptionId}`
  const { data } =
    await api.get<SubscriptionByIdResponseType>(url)
  return data
}
const useSubscriptionById = (subscriptionId: string) => {
  const { authData } = useAuth()
  const isAuthenticated = !!authData?.accessToken
  return useQuery({
    queryKey: [ENDPOINTS.SUBSCRIPTIONS, subscriptionId],
    queryFn: () => getSubscriptionById(subscriptionId),
    enabled: isAuthenticated && !!subscriptionId,
  })
}
export default useSubscriptionById
